import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .direct-group-layout {
      display: grid;
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        [last-line];
      padding-bottom: calc(30rem / var(--default-rem-px-count));

      .header {
        grid-column: 2 / 8;
        grid-row: 2;

        border-bottom: 1px solid #ccc;
      }

      .account-information {
        grid-column: 2 / 8;
        grid-row: 3;
      }

      .project-manager {
        grid-column: 2 / 8;
        grid-row: 4;
      }

      .downloads {
        grid-column: 2 / 8;
        grid-row: 5;
      }
    }

    .direct-group-layout-with-feature-img {
      display: grid;
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        [last-line];
      padding-bottom: calc(30rem / var(--default-rem-px-count));

      p {
        font-size: var(--fs-body-small);
      }

      .header {
        grid-column: 2 / 8;
        grid-row: 2;
      }

      .feature-img-wrapper {
        grid-column: 2 / 8;
        grid-row: 3;
        display: flex;

        img {
          max-width: 100%;
          max-height: calc(320rem / var(--default-rem-px-count));
          margin: auto;
        }
      }

      .account-information {
        grid-column: 2 / 8;
        grid-row: 4;
      }

      .project-manager {
        grid-column: 2 / 8;
        grid-row: 5;
      }

      .downloads {
        grid-column: 2 / 8;
        grid-row: 6;
      }
    }

    .account-information,
    .project-manager,
    .downloads {
      display: flex;
    }

    .mobile-only {
      display: flex;
    }

    .desktop-only {
      display: none;
    }

    .header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .company-logo {
      display: flex;
      flex-direction: row;
      gap: calc(14rem / var(--default-rem-px-count));
    }

    .section-wrapper {
      display: flex;
      flex-direction: column;
      gap: calc(14rem / var(--default-rem-px-count));
    }

    .return-to-groups {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    .return-to-groups svg {
      transform: rotate(180deg);
      height: calc(8em / var(--default-rem-px-count));
      width: calc(8em / var(--default-rem-px-count));
    }

    .return-to-groups p {
      padding-left: calc(8em / var(--default-rem-px-count));
    }

    .header-text {
      white-space: nowrap;
      margin: auto 0;
    }

    /* Section headings: small medium-weight labels, pinned to label-small. */
    h3 {
      font-size: var(--fs-label-small);
      line-height: var(--lh-label-small);
      letter-spacing: var(--ls-label-small);
      font-weight: var(--fw-medium);
    }

    .font-size-small {
      font-size: var(--fs-caption);
      letter-spacing: var(--ls-caption);
      line-height: var(--lh-caption);
    }

    .downloads .section-details {
      display: flex;
      flex-direction: column;
    }

    .manager-name {
      font-weight: 500;
    }

    .mobile-only {
      display: initial;
    }

    .section-wrapper-closed .section-details {
      display: none;
    }

    .section-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: calc(40rem / var(--default-rem-px-count));
      border-bottom: 1px solid #222222;
    }

    @media (min-width: 600px) {
      .direct-group-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          [last-line];
        padding-bottom: 0px;

        .header {
          grid-column: 2 / 14;
          grid-row: 2;
        }

        .account-information {
          grid-column: 2 / 6;
          grid-row: 3;
        }

        .project-manager {
          grid-column: 7 / 10;
          grid-row: 3;
        }

        .downloads {
          grid-column: 11 / 14;
          grid-row: 3;
        }
      }

      .direct-group-layout-with-feature-img {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          [last-line];
        padding-bottom: calc(40rem / var(--default-rem-px-count));

        .header {
          grid-column: 2 / 14;
          grid-row: 2;
        }

        .feature-img-wrapper {
          grid-column: 2 / 9;
          grid-row: 3 / 5;
          display: flex;
          max-height: calc(500rem / var(--default-rem-px-count));

          img {
            max-width: 100%;
            max-height: calc(500rem / var(--default-rem-px-count));
            margin: auto;
          }
        }

        .account-information {
          grid-column: 9 / 14;
          grid-row: 3;

          border-bottom: 1px solid #cccccc;

          .section-details {
            padding-right: 20%;
          }
        }

        .project-manager {
          grid-column: 9 / 11;
          grid-row: 4;

          margin-top: calc(30rem / var(--default-rem-px-count));
        }

        .downloads {
          grid-column: 11 / 14;
          grid-row: 4;

          margin-top: calc(30rem / var(--default-rem-px-count));
        }
      }

      .mobile-only {
        display: none;
      }

      .desktop-only {
        display: flex;
      }

      .header {
        padding-bottom: calc(20rem / var(--default-rem-px-count));
        margin-bottom: calc(20rem / var(--default-rem-px-count));
      }

      .section-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: unset;
        border-bottom: none;
      }

      .section-wrapper-closed .section-details {
        display: flex;
        flex-direction: column;
        gap: calc(8rem / var(--default-rem-px-count));
        padding-bottom: calc(20rem / var(--default-rem-px-count));
      }

      .mobile-only {
        display: none;
      }
    }
  `,
];
